import { render, staticRenderFns } from "./HallazgosEdicion.vue?vue&type=template&id=1c1e5cd2&scoped=true"
import script from "./HallazgosEdicion.vue?vue&type=script&lang=js"
export * from "./HallazgosEdicion.vue?vue&type=script&lang=js"
import style0 from "./HallazgosEdicion.vue?vue&type=style&index=0&id=1c1e5cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e5cd2",
  null
  
)

export default component.exports